/**
 * Sparkle — hue-cycling SVG icon for the morph bar's leading affordance.
 * Per the reference component (`/tmp/agent-search-2/AgentSearch.tsx:87-114`):
 * `useId()` keeps gradient defs unique per instance so multiple sparkles
 * in the same DOM don't share gradients.
 */

import { useId } from 'react'

import { cn } from '../lib/cn'

export interface SparkleProps {
  size?: number
  className?: string
}

export function Sparkle({ size = 16, className }: SparkleProps) {
  const gradId = `agent-spark-${useId().replace(/:/g, '')}`
  return (
    <span className={cn('as-sparkle', className)} style={{ width: size, height: size }} aria-hidden>
      {/* width/height attrs (not just viewBox) so the SVG can't render at
          its 300x150 default during the FOUC window before
          ensureAgentSearchStyles() injects `.as-sparkle svg { width: 100% }`
          — visible on Next.js SSR reloads as a giant magenta star. */}
      <svg width={size} height={size} viewBox="0 0 16 16" fill="none">
        <defs>
          <linearGradient id={gradId} x1="0" y1="0" x2="1" y2="1">
            <stop className="as-sparkle-stop-1" offset="0%" stopColor="#6366f1" />
            <stop className="as-sparkle-stop-2" offset="100%" stopColor="#ec4899" />
          </linearGradient>
        </defs>
        <path d="M8 1.5L9.4 5.6L13.5 7L9.4 8.4L8 12.5L6.6 8.4L2.5 7L6.6 5.6L8 1.5Z" fill={`url(#${gradId})`} />
        <path
          d="M13 11L13.5 12.5L15 13L13.5 13.5L13 15L12.5 13.5L11 13L12.5 12.5L13 11Z"
          fill={`url(#${gradId})`}
          opacity="0.7"
        />
      </svg>
    </span>
  )
}
